import { useState } from "react";
import { Link } from "react-scroll";
import { FaBars } from "react-icons/fa";
import { GrClose } from "react-icons/gr";
import resume from "../../assets/resume/Bikash_Devsharma_Resume_Frontend.pdf";
import "./Navbar.css";

const Navbar = () => {
  const [nav, setNav] = useState(false);

  const openNav = () => {
    setNav(!nav);
  };

  const mobileNavLinks = (
    <>
      <li className="hover:text-[#2979ff]" onClick={openNav}>
        <a href="#home">Home</a>
      </li>
      <li className="hover:text-[#2979ff]" onClick={openNav}>
        <a href="#about">About</a>
      </li>
      <li className="hover:text-[#2979ff] " onClick={openNav}>
        <a href="#projects">Projects</a>
      </li>
      <li className="hover:text-[#2979ff]" onClick={openNav}>
        <a href="#contact">Contact</a>
      </li>
      <li className="text-[#2979ff] bg-transparent border-2 border-[#2979ff] py-[6px] px-4 rounded hover:bg-[#2979ff] hover:text-white">
        <a
          target="_blank"
          rel="noreferrer"
          className="text-center"
          href={resume}
        >
          Resume
        </a>
      </li>
    </>
  );

  const navLinks = (
    <>
      <li className="hover:text-[#2979ff] duration-300 transition cursor-pointer">
        <Link to="home" spy={true} smooth={true} offset={-100} duration={500}>
          Home
        </Link>
      </li>
      <li className="hover:text-[#2979ff] duration-300 transition cursor-pointer">
        <Link to="about" spy={true} smooth={true} offset={-80} duration={500}>
          About
        </Link>
      </li>
      <li className="hover:text-[#2979ff] duration-300 transition cursor-pointer">
        <Link to="projects" spy={true} smooth={true} offset={-30} duration={500}>Projects</Link>
      </li>
      <li className="hover:text-[#2979ff] duration-300 transition cursor-pointer">
        <Link to="contact" spy={true} smooth={true} offset={-50} duration={500}>Contact</Link>
      </li>
      <li className="text-[#2979ff] bg-transparent border-2 border-[#2979ff] py-[6px] px-4 rounded hover:bg-[#2979ff] hover:text-white duration-500 transition cursor-pointer">
        <a
          target="_blank"
          rel="noreferrer"
          className="text-center"
          href={resume}
        >
          Resume
        </a>
      </li>
    </>
  );

  return (
    <div className="fixed w-full bg-white z-50">
      <nav>
        {/* mobile */}
        <div
          className={`flex flex-col w-full h-screen fixed top-0 left-full bg-white z-50 justify-center items-center transition-all duration-500 ease-in-out ${
            nav ? "open-nav " : ""
          }`}
        >
          <div
            onClick={openNav}
            className="text-3xl absolute top-6 right-6 cursor-pointer transition-all duration-300 hover:text-[#2979ff]"
          >
            <GrClose />
          </div>
          <ul className=" flex flex-col list-none justify-center items-center text-center gap-12 text-2xl font-semibold">
            {mobileNavLinks}
          </ul>
        </div>

        {/* desktop */}
        <div className="shadow-md">
          <div className="max-w-[1280px] h-auto flex justify-between items-center bg-transparent lg:text-white mx-auto z-50 p-6 ">
            <a href="/">
              <div className="flex justify-center items-center">
                <p className="text-black normal-case text-xl font-bold tracking-[.08em] cursor-pointer">
                  BIKASH DEVSHARMA
                </p>
              </div>
            </a>

            <ul className="hidden lg:flex items-center list-none text-black font-bold text-lg gap-5 ">
              {navLinks}
            </ul>

            {/* mobile */}
            <div
              className="text-3xl flex lg:hidden cursor-pointer transition-all duration-300 hover:text-[#2979ff]"
              onClick={openNav}
            >
              <FaBars />
            </div>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Navbar;
